import styled from "styled-components";
import { colors } from "./colors";

export const Header = styled.header`
  padding: 15px 20px;
  background-color: ${colors.surface};
  border-bottom: 1px solid ${colors.textLight};
  border-radius: 12px; /* Curved edges */
  position: sticky;
  top: 0;
  z-index: 10;
  margin: 0 20px 20px 20px; /* Add margin to separate from content and create space for rounded corners */
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center; /* Center the title and icon */
  gap: 10px; /* Space between icon and title */
`;

export const Icon = styled.span`
  color: ${colors.textDark};
  display: flex;
  align-items: center;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  color: ${colors.textDark};
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;